// @flow
import * as React from 'react';
import { Field, reduxForm } from 'redux-form';
import { Row, Col, Button, Form } from 'react-bootstrap';
import { CSSTransitionGroup } from 'react-transition-group';
import { FirstChild } from '../../helpers';
import Input from '../../components/Input';

type Props = {
  settings: Object,
  isSaving: boolean,
  successMsg: string,
  errorMsg: string,
  handleSubmit: (v: Object) => void
};

const SettingsEmailForm = (props: Props) => (
  <Form onSubmit={props.handleSubmit}>
    <Row>
      <Col sm={12} className="form-input">
        <Field
          className="inline-block"
          component={Input}
          type="textarea"
          placeholder={
            props.settings && props.settings.disclaimerEmail
              ? props.settings.disclaimerEmail.description
              : ''
          }
          name="disclaimerEmail.value"
          label="Disclaimer Email"
          componentClass="textarea"
          rows="15"
        />
      </Col>
    </Row>
    <Row>
      <Col sm={12} className="form-input">
        <Field
          className="inline-block"
          component={Input}
          type="textarea"
          placeholder={
            props.settings && props.settings.invitationExistingEmail
              ? props.settings.invitationExistingEmail.description
              : ''
          }
          name="invitationExistingEmail.value"
          label="Invitation Existing Email"
          componentClass="textarea"
          rows="15"
        />
      </Col>
    </Row>
    <Row>
      <Col sm={12} className="form-input">
        <Field
          className="inline-block"
          component={Input}
          type="textarea"
          placeholder={
            props.settings && props.settings.invitationNewEmail
              ? props.settings.invitationNewEmail.description
              : ''
          }
          name="invitationNewEmail.value"
          label="Invitation New Email"
          componentClass="textarea"
          rows="15"
        />
      </Col>
    </Row>
    <Row>
      <Col sm={12} className="form-input">
        <Field
          className="inline-block"
          component={Input}
          type="textarea"
          placeholder={
            props.settings && props.settings.mapDataProcessErrorEmail
              ? props.settings.mapDataProcessErrorEmail.description
              : ''
          }
          name="mapDataProcessErrorEmail.value"
          label="Map Data Process Error Email"
          componentClass="textarea"
          rows="15"
        />
      </Col>
    </Row>
    <Row>
      <Col sm={12} className="form-input">
        <Field
          className="inline-block"
          component={Input}
          type="textarea"
          placeholder={
            props.settings && props.settings.mapDataProcessSuccessEmail
              ? props.settings.mapDataProcessSuccessEmail.description
              : ''
          }
          name="mapDataProcessSuccessEmail.value"
          label="Map Data Process Success Email"
          componentClass="textarea"
          rows="15"
        />
      </Col>
    </Row>
    <Row>
      <Col sm={12} className="form-input">
        <Field
          className="inline-block"
          component={Input}
          type="textarea"
          placeholder={
            props.settings && props.settings.resetPasswordEmail
              ? props.settings.resetPasswordEmail.description
              : ''
          }
          name="resetPasswordEmail.value"
          label="Reset Password Email"
          componentClass="textarea"
          rows="15"
        />
      </Col>
    </Row>
    <Row>
      <Col sm={12} className="form-input">
        <Field
          className="inline-block"
          component={Input}
          type="textarea"
          placeholder={
            props.settings && props.settings.sendCodeSms
              ? props.settings.sendCodeSms.description
              : ''
          }
          name="sendCodeSms.value"
          label="Send Code Sms"
          componentClass="textarea"
          rows="15"
        />
      </Col>
    </Row>
    <Row>
      <Col sm={12} className="form-input">
        <Field
          className="inline-block"
          component={Input}
          type="textarea"
          placeholder={
            props.settings && props.settings.verificationEmail
              ? props.settings.verificationEmail.description
              : ''
          }
          name="verificationEmail.value"
          label="Verification Email"
          componentClass="textarea"
          rows="15"
        />
      </Col>
    </Row>
    <Row>
      <Col sm={12} className="form-input">
        <Field
          className="inline-block"
          component={Input}
          type="textarea"
          placeholder={
            props.settings && props.settings.requestOrganisationTypeUpdateEmail
              ? props.settings.requestOrganisationTypeUpdateEmail.description
              : ''
          }
          name="requestOrganisationTypeUpdateEmail.value"
          label="Request Organisation Type Update Email"
          componentClass="textarea"
          rows="15"
        />
      </Col>
    </Row>
    <Row>
      <Col sm={12} className="form-input">
        <Field
          className="inline-block"
          component={Input}
          type="textarea"
          placeholder={
            props.settings && props.settings.amBookingLodgementEmail
              ? props.settings.amBookingLodgementEmail.description
              : ''
          }
          name="amBookingLodgementEmail.value"
          label="AM Booking Lodgement Email Text"
          componentClass="textarea"
          rows="15"
        />
      </Col>
    </Row>
    <Row>
      <Col sm={12}>
        <Button
          bsStyle="primary"
          type="submit"
          className="relative-padding"
          disabled={props.isSaving}
        >
          {props.isSaving ? 'Saving...' : 'Save'}
        </Button>
      </Col>
    </Row>
    <br />
    <Row>
      <Col sm={12}>
        <CSSTransitionGroup
          component={FirstChild}
          transitionName="fade"
          transitionEnterTimeout={300}
          transitionLeaveTimeout={300}
        >
          {props.successMsg ? (
            <p key="success" className="text-success">
              {props.successMsg}
            </p>
          ) : null}
        </CSSTransitionGroup>
      </Col>
    </Row>
    {props.errorMsg && (
      <div className="alert alert-danger">{props.errorMsg}</div>
    )}
  </Form>
);

export default reduxForm({
  form: 'settingsEmailForm'
})(SettingsEmailForm);



// WEBPACK FOOTER //
// ./src/containers/settings/SettingsEmailForm.js